<template>
<div ref="mv" class="p-lp__mv">
    <div class="c-mv" :style="setMvHeight">
        <div class="c-mv__bg">
            <picture>
                <source media="(max-width: 800px)" srcset="/specialoffer/assets/img/specialoffer/mv/mv-sp.jpg">
                <img loading="lazy" src="/specialoffer/assets/img/specialoffer/mv/mv-pc.jpg" alt="" width="1170" height="646">
            </picture>
        </div>
        <div class="c-mv__logo">
            <img src="/specialoffer/assets/img/common/logo.png" alt="WITH EARTH GARDEN" width="174" height="122">
        </div>
        <Transition name="c-mv__title">
            <div v-show="isShowTitle" class="c-mv__title">
                <div class="c-mv__title__limit">
                    <p>先着順！</p>
                </div>
                <div class="c-mv__title__wrap">
                    <h2>モデルハウス<br>特別販売</h2>
                    <p>Amazonギフトカード<br class="u-none-b--sp">プレゼント<br class="u-none-b--pc">キャンペーン<br class="u-none-b--sp">同時開催中！</p>
                </div>
            </div>
        </Transition>
    </div>
</div>
</template>

<script>

import { gsap, Quart } from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default {
    data() {
        return {
            mvWidth: 0,
            mvHeight: 0,
        }
    },
    computed: {
        setMvHeight() {
            if (this.mvHeight > 0) {
                return `height: ${this.mvHeight}px;`;
            } else {
                return '';
            }
        },
        isShowTitle() {
            return this.$store.getters.showMvTitle;
        }
    },
    mounted() {
        const timeline = gsap.fromTo(this.$el.querySelector('.c-mv__bg'), {
            y: '0%',
        }, {
            y: '50%',
            ease: 'none',
            scrollTrigger: {
                // id: 'gallery-pallarax',
                trigger: this.$el,//galleryContainer.value,
                start: 'top top',
                end: 'bottom top',
                scrub: true,
                invalidateOnRefresh: true,
            }
        });

        this.resize();
        window.addEventListener('resize', this.resize);
    },
    methods: {
        resize() {
            if (window.matchMedia('(max-width: 800px)').matches) {
                //SP
                if (this.mvWidth !== window.innerWidth) {
                    this.mvHeight = innerHeight;
                }
            } else {
                //PC
                this.mvHeight = 0;
            }

            this.mvWidth = window.innerWidth;
        }
    }
}

</script>